import { P } from "../../../../../../AbstractElements";
import CommonFileUpload from "../../../../../Common/CommonFileUpload";
import ProductGallery from "./ProductGallery";

const ProductTwo = () => {
  return (
    <div className="sidebar-body">
      <div className="product-upload">
        <P>Product Image </P>
        <CommonFileUpload multiple />
      </div>
      <ProductGallery />
    </div>
  );
};

export default ProductTwo;
